import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app";
import reportWebVitals from "./reportWebVitals";
import { RouterProvider } from "react-router-dom";
import { router } from "./app/routes";
import "hammerjs";
import "./css/fontawesome/css/all.css";
import "./css/site.scss";
import { ErrorBoundary } from "./features";

const container = document.getElementById("root")!;
const root = createRoot(container);

window.onerror = function (message, source, lineno, colno, error) {
  console.error(
    "Ooops... An error just ocurred:",
    message,
    source,
    lineno,
    colno,
    error
  );
  return true;
};

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ErrorBoundary>
        <RouterProvider router={router}></RouterProvider>
      </ErrorBoundary>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

